import React from "react";
import { motion } from "framer-motion";
import { Play, Film } from "lucide-react";
import Particles from "./Particles";
import { HERO_BG } from "../data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
const playAudio = () => window.dispatchEvent(new CustomEvent("oli-play", { detail: 0 }));

const Lasers = () => (
  <div className="pointer-events-none absolute inset-0 z-[1] overflow-hidden opacity-60">
    {[15, 35, 55, 75, 90].map((left, i) => (
      <motion.div
        key={i}
        className="laser"
        style={{ left: `${left}%`, background: i % 2 ? "linear-gradient(180deg,transparent,rgba(176,38,255,0.7),transparent)" : undefined }}
        initial={{ rotate: -8, opacity: 0.2 }}
        animate={{ rotate: [-8, 8, -8], opacity: [0.2, 0.8, 0.2] }}
        transition={{ duration: 5 + i, repeat: Infinity, ease: "easeInOut" }}
      />
    ))}
  </div>
);

export const Hero = () => {
  return (
    <section id="accueil" className="section grain relative flex min-h-screen items-center">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/60 to-[#050505]" />
      <div className="orb orb-blue z-0" style={{ width: 500, height: 500, top: "-10%", left: "-5%" }} />
      <div className="orb orb-purple z-0" style={{ width: 450, height: 450, bottom: "5%", right: "-5%" }} />

      <Lasers />
      <Particles count={30} />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mb-5 font-heading text-sm uppercase tracking-[0.4em] text-white/60"
        >
          DJ · Producteur · Méditerranée
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="wordmark neon-text font-display text-6xl font-black leading-[0.9] sm:text-7xl lg:text-[9rem]"
        >
          OLI.VERO
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="mt-6 max-w-xl font-body text-lg text-white/75"
        >
          De la Sicile à Ibiza — house, dance, electro et saxophone.
          L'énergie estivale de la Méditerranée, prête pour les plus grandes scènes du monde.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-10 flex flex-col gap-4 sm:flex-row"
        >
          <button
            data-testid="hero-listen-btn"
            onClick={() => { playAudio(); scrollTo("musique"); }}
            className="btn-glow flex items-center justify-center gap-3 rounded-full bg-gradient-to-r from-electric to-neon px-8 py-4 font-heading text-base font-semibold text-white"
          >
            <Play size={20} fill="currentColor" /> ÉCOUTER MAINTENANT
          </button>
          <button
            data-testid="hero-clips-btn"
            onClick={() => scrollTo("clips")}
            className="flex items-center justify-center gap-3 rounded-full border border-white/20 glass px-8 py-4 font-heading text-base font-semibold text-white transition-colors duration-300 hover:border-white/50"
          >
            <Film size={20} /> REGARDER LES CLIPS
          </button>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2">
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="flex h-10 w-6 items-start justify-center rounded-full border border-white/30 p-1"
        >
          <span className="h-2 w-1 rounded-full bg-white/70" />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
